import { FC } from 'react';
import { Chip, numberFormat, Text } from '@mofid-securities/uikit';
import { useIsMasked } from '@/hooks/isMasked';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useFindFundAssetByFundCode } from '@/modules/invest/subModules/fund/hooks/useFindFundAsset';
import { useGetUserStatus } from '@/userStatus/hooks';
import { toFormattedDate } from '@/utils/date';
import { generateEfficiencyForChip } from '@/modules/invest/utils/generateEfficiencyForChip';

export const AssetEfficiency: FC = () => {
  const fundCode = useGetFundCodeFromQuery();
  const { isMasked, maskedSymbol } = useIsMasked('sideBarMasked');
  const { isVerified } = useGetUserStatus();

  // * Always mask for unverified user
  const shouldMask = !isVerified || isMasked;

  const { fundAsset } = useFindFundAssetByFundCode(fundCode);

  const {
    existingUnitsProfitLoss,
    existingUnitsProfitLossEfficiency,
    type,
    lastSync,
    lastSyncCardexDate,
  } = fundAsset || {};

  const { variant, formattedEfficiency } = generateEfficiencyForChip(
    existingUnitsProfitLossEfficiency || 0
  );

  const lastSyncDate = type === 'ETF' ? lastSyncCardexDate : lastSync;

  return (
    <div>
      <div className="flex items-center gap-x-2">
        <Text
          className="text-gray-filled-secondary-enabled"
          component="h4"
          size="sm"
          weight="demibold"
        >
          سود و زیان
        </Text>
        {lastSyncDate ? (
          <Text
            className="text-gray-filled-tertiary-enabled"
            component="span"
            size="xxs"
            weight="medium"
          >
            بروزرسانی: {toFormattedDate(lastSyncDate, 'D MMMM', true)}
          </Text>
        ) : null}
      </div>
      <div className="flex items-center justify-end gap-x-2">
        {!shouldMask && (
          <Chip className="ltr" variant={variant}>
            {formattedEfficiency}
          </Chip>
        )}

        {existingUnitsProfitLoss ? (
          <div className="flex items-center gap-x-1">
            <Text
              className="text-gray-filled-primary-enabled ltr"
              size="md"
              weight="demibold"
            >
              {shouldMask
                ? maskedSymbol
                : existingUnitsProfitLoss
                  ? numberFormat(existingUnitsProfitLoss, 0)
                  : '-'}
            </Text>
            <Text
              className="text-gray-filled-primary-enabled"
              size="xxs"
              weight="medium"
            >
              ریال
            </Text>
          </div>
        ) : null}
      </div>
    </div>
  );
};
